import { IoCloseOutline } from 'react-icons/io5';
import { CheckoutData } from '.';
import PaymentForm from './PaymentForm';
import { Divider } from 'antd';
import { formatCurrency } from 'src/utils/string';

interface CheckoutModalProps {
  isOpen: boolean;
  onClose: (clearCart?: boolean) => void;
  hours: number;
  checkoutData: CheckoutData;
}

export default function CheckoutModal({
  isOpen,
  onClose,
  hours,
  checkoutData,
}: CheckoutModalProps) {
  if (!isOpen) return null;

  const basePrice = Number(checkoutData.base_price) / 100;
  const totalPrice = Number(checkoutData.amount) / 100;
  const fee = totalPrice - basePrice;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50">
      <div className="relative max-h-[80vh] w-[90%] max-w-[500px] overflow-auto rounded-lg bg-white p-8 shadow-lg">
        <button
          onClick={() => onClose()}
          className="absolute right-4 top-4 text-2xl text-gray-500 transition hover:text-gray-700"
        >
          <IoCloseOutline />
        </button>

        <h1 className="mb-6 text-xl font-semibold text-blue-700">
          Complete your payment
        </h1>

        {/* Order Summary */}
        <div className="mb-6 rounded-md bg-gray-100 p-4">
          <p className="font-semibold">Order summary</p>
          <Divider style={{ margin: '10px 0' }} />

          <OrderRow
            label={`${hours} hour${hours !== 1 ? 's' : ''}`}
            value={basePrice}
          />

          <OrderRow label="Credit card fee (3%)" value={fee} />

          <Divider style={{ margin: '10px 0' }} />

          <OrderRow label="Order total" value={totalPrice} labelBold />
        </div>

        <PaymentForm onClose={onClose} checkoutData={checkoutData} />
      </div>
    </div>
  );
}

function OrderRow({
  label,
  value,
  labelBold,
}: {
  label: string;
  value: number;
  labelBold?: boolean;
}) {
  return (
    <div className="flex w-full justify-between">
      <span className={labelBold ? 'font-semibold' : ''}>{label}</span>
      <span className="font-semibold">{formatCurrency(value)}</span>
    </div>
  );
}
